/**
 * API Configuration for the Sales Rep Draft Order + Order List features.
 *
 * ALL backend calls go through the ceres-b2b-app App Proxy, SAME-ORIGIN —
 * never the API Gateway URL directly. Proxy prefix/subpath come from
 * apps/shopify.app.ceres-b2b-app-*.toml ([app_proxy] prefix="apps",
 * subpath="mr-middleware"): Shopify forwards /apps/mr-middleware/<path> to
 * the backend's <path> at its stage root and HMAC-signs the request, e.g.
 * /apps/mr-middleware/v1/sy/create-draft-order -> https://.../sit/v1/sy/create-draft-order.
 *
 * Every endpoint requires an Authorization: Bearer token minted via
 * CUSTOMER_AUTH_PROXY — use proxyFetch() from js/objects/proxyAuth.js, which
 * handles minting/caching. The backend derives the company server-side from
 * the signed customer id; request bodies never carry a company id.
 */
const PROXY_ROOT = '/apps/mr-middleware';
const API_BASE = `${PROXY_ROOT}/v1/sy`;

export const API_ENDPOINTS = {
  // Draft Order Operations
  CREATE_DRAFT_ORDER: `${API_BASE}/create-draft-order`,
  MARK_DRAFT_PAID: `${API_BASE}/mark-draft-paid`,
  SEND_DRAFT_INVOICE: `${API_BASE}/send-draft-invoice`,
  DRAFT_ORDER_BY_ID: `${API_BASE}/draft-order-by-id`,
  DRAFT_ORDERS_BY_COMPANY: `${API_BASE}/draft-orders-by-company`,
  DELETE_DRAFT_ORDER: `${API_BASE}/delete-draft-order`,

  // The rep cart's "Calculate Shipping" link (COB2B-765 UAT item 2): Shopify's
  // Shipping/GST/Total for the draft Submit Order would create from the cart.
  DELIVERY_RATE: `${API_BASE}/delivery-rate`,

  // Company & Contact Operations
  COMPANY_CONTACTS: `${API_BASE}/company-contacts`,
  COMPANY_METAFIELD: `${API_BASE}/company-metafield`,

  // Credit balance check (COB2B-762) — GST-exclusive total of the company's OPEN,
  // UNFULFILLED orders, netted off the D3-lagging remaining_balance metafield before
  // the cart is compared against it.
  COMPANY_OPEN_ORDERS: `${API_BASE}/company-open-orders`,

  // Sales-rep location switch from the storefront (COB2B-809). Rep-only. The first two
  // take the company member picked from COMPANY_CONTACTS: list that member's role
  // locations, then set one — grants the rep a role there + updates
  // custom.current_location_id. The native rebind is reconcileCartCompany()'s job, and
  // once it has landed it calls PRUNE_ROLES to leave the rep on that one location.
  SALES_REP_LOCATIONS: `${API_BASE}/sales-rep-locations`,
  SALES_REP_SET_LOCATION: `${API_BASE}/sales-rep-set-location`,
  SALES_REP_PRUNE_ROLES: `${API_BASE}/sales-rep-prune-roles`,

  // Order List (saved lists) + the token-mint endpoint for proxyAuth.js
  CUSTOMER_AUTH_PROXY: `${PROXY_ROOT}/customer-auth/`,
  ORDER_LIST_PROXY: `${PROXY_ROOT}/order-list`,

  // Catalogue PDF export (COB2B-227). Paths are owned by the backend's catalogue-export
  // service; declared here so the theme half can be built against them.
  CATALOGUE_EXPORT_SUBMIT: `${API_BASE}/catalogue-export`,
  CATALOGUE_EXPORT_LIST: `${API_BASE}/catalogue-exports`,
  CATALOGUE_EXPORT_DOWNLOAD: `${API_BASE}/catalogue-export/download`,
};

export default API_ENDPOINTS;
